export const GET_ALL_AREAS = "GET_ALL_AREAS";
export const GET_ALL_ZONES = "GET_ALL_ZONES";
export const GET_AREA_STATUS = "GET_AREA_STATUS";
export const GET_ALL_BUILDING = "GET_ALL_BUILDING";